/* Source-style option flyouts use one native product form and its real variants. */
(function () {
  'use strict';
  function boot() {
    if (!window.TC || !TC.init) return;
    TC.init('[data-tc-modal-options]', function (owner) {
      var root = owner.closest('[data-tc-product]');
      if (!root) return;
      var modals = Array.from(owner.querySelectorAll('.tc-option-modal'));
      modals.forEach(function (modal) {
        modal.dataset.tcOptionOwner = owner.id;
        modal.dataset.block = owner.dataset.block;
        modal.style.cssText += owner.getAttribute('style') || '';
        root.appendChild(modal);
      });
      var data = owner.querySelector('[data-tc-modal-variants]');
      var variants = [];
      try { variants = data ? JSON.parse(data.textContent) : []; } catch (e) { return; }
      var originals = root.querySelector('[data-tc-variants]');
      var originalVariants = originals ? JSON.parse(originals.textContent) : [];
      var idInput = root.querySelector('[data-tc-variant-id]');
      var selected = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0];
      var options = selected ? selected.options.slice() : [];
      function candidate(position, value) {
        return variants.filter(function (variant) {
          return variant.options.every(function (item, index) { return item === (index === position - 1 ? value : options[index]); });
        })[0];
      }
      function paint() {
        owner.querySelectorAll('[data-tc-option-label]').forEach(function (label) { label.textContent = options[Number(label.dataset.tcOptionLabel) - 1]; });
        modals.forEach(function (modal) { modal.querySelectorAll('[data-tc-native-pick]').forEach(function (button) {
          var position = Number(button.dataset.tcOptionPosition), value = button.dataset.tcOptionValue;
          var chosen = options[position - 1] === value;
          var variant = candidate(position, value);
          button.disabled = !variant || !variant.available;
          button.setAttribute('aria-pressed', String(chosen));
          button.classList.toggle('selected', chosen);
          var swatch = button.querySelector('.swatch-value'); if (swatch) swatch.classList.toggle('selected', chosen);
          var row = button.closest('[data-tc-native-row]');
          if (row) { row.classList.toggle('selected-row', chosen); row.classList.toggle('table-basic-outofstock', button.disabled); var radio = row.querySelector('[data-tc-native-radio]'); if (radio) radio.classList.toggle('is-selected', chosen); }
        }); });
      }
      function tab(modal, name) {
        modal.querySelectorAll('[data-tc-option-tab]').forEach(function (button) { var active = button.dataset.tcOptionTab === name; button.classList.toggle('active', active); button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1; });
        modal.querySelectorAll('[data-tc-option-pane]').forEach(function (pane) { var active = pane.dataset.tcOptionPane === name; pane.hidden = !active; pane.classList.toggle('show', active); pane.classList.toggle('active', active); });
      }
      root.addEventListener('click', function (event) {
        if (!owner.contains(event.target) && !modals.some(function (modal) { return modal.contains(event.target); })) return;
        var guide = event.target.closest('[data-tc-option-guide]');
        var trigger = event.target.closest('[data-tc-option-trigger]');
        if (guide || trigger) { var modal = document.querySelector((guide || trigger).getAttribute('data-tc-open')); if (modal && modal.querySelector('[data-tc-option-tab]')) tab(modal, guide ? 'fit' : 'choices'); }
        var tabButton = event.target.closest('[data-tc-option-tab]');
        if (tabButton) { event.preventDefault(); tab(tabButton.closest('.modal'), tabButton.dataset.tcOptionTab); return; }
        var ref = event.target.closest('[data-tc-swatch]');
        if (ref && !data) { var label = owner.querySelector('[data-tc-reference-option-label]'); if (label) label.textContent = ref.dataset.tcValue; TC.overlay.close(ref.closest('.modal')); return; }
        var button = event.target.closest('[data-tc-native-pick]');
        var row = event.target.closest('[data-tc-native-row]');
        if (!button && row) button = row.querySelector('[data-tc-native-pick]');
        if (!button || button.disabled) return;
        event.preventDefault();
        var variant = candidate(Number(button.dataset.tcOptionPosition), button.dataset.tcOptionValue);
        if (!variant || !variant.available) return;
        options = variant.options.slice();
        var original = originalVariants.filter(function (v) { return v.id === variant.id; })[0];
        root.dispatchEvent(new CustomEvent('tc:variant:select', { detail: Object.assign({}, original, { priceText: variant.priceText }) }));
        paint();
        TC.overlay.close(button.closest('.modal'));
      });
      root.addEventListener('keydown', function (event) {
        if (!modals.some(function (modal) { return modal.contains(event.target); })) return;
        var button = event.target.closest('[data-tc-option-tab]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); var modal = button.closest('.modal'), name = button.dataset.tcOptionTab === 'choices' ? 'fit' : 'choices';
        if (event.key === 'Home') name = 'choices'; if (event.key === 'End') name = 'fit'; tab(modal, name); modal.querySelector('[data-tc-option-tab="' + name + '"]').focus();
      });
      ['tc:overlay:open', 'tc:overlay:close'].forEach(function (type) { root.addEventListener(type, function (event) { var modal = event.target; if (!modals.includes(modal)) return; owner.querySelectorAll('[aria-controls="' + modal.id + '"]').forEach(function (trigger) { if (trigger.hasAttribute('data-tc-option-trigger')) trigger.setAttribute('aria-expanded', String(type === 'tc:overlay:open')); }); }); });
      owner.addEventListener('shopify:block:select', function () { var modal = modals[0]; if (modal) TC.overlay.open(modal); });
      if (selected) paint();
    });
  }
  if (window.TC && TC.init) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
